import {z} from 'zod';

/**
 * Zod transform that accepts a single string or an array of strings and returns
 * either the first value or undefined. Used for query params that semantically
 * take one value even if Hono's req.queries() returns an array.
 */
export const singleString = z
  .union([z.string(), z.array(z.string())])
  .optional()
  .transform((val) => {
    if (!val) {
      return undefined;
    }
    return Array.isArray(val) ? val[0] : val;
  });

/**
 * Zod transform that accepts a single string or an array of strings and splits
 * on comma, returning a flattened array. Handles both `?x=a,b` and `?x=a&x=b`.
 */
export const multiString = z
  .union([z.string(), z.array(z.string())])
  .optional()
  .transform((val) => {
    if (!val) {
      return undefined;
    }
    if (Array.isArray(val)) {
      return val.flatMap((v) => v.split(','));
    }
    return val.split(',');
  });
